export const GOVERNANCE_LIFECYCLE_STATUSES = Object.freeze({
  DRAFT: "DRAFT",
  UNDER_REVIEW: "UNDER_REVIEW",
  BOARD_DISCUSSION: "BOARD_DISCUSSION",
  DECISION_PENDING: "DECISION_PENDING",
  RESOLVED: "RESOLVED",
  MONITORING: "MONITORING",
});

// Retain the established export name for consumers of the Decision Matter model.
export const DECISION_MATTER_STATUSES = GOVERNANCE_LIFECYCLE_STATUSES;

const STATUS_VALUES = new Set(
  Object.values(GOVERNANCE_LIFECYCLE_STATUSES)
);

function normalizeStatus(status) {
  const normalized = String(status || "")
    .trim()
    .toUpperCase();

  return STATUS_VALUES.has(normalized)
    ? normalized
    : DECISION_MATTER_STATUSES.DRAFT;
}

/*
 * A DecisionMatter is a governance dossier, not an analytical decision.
 * In particular, this factory deliberately performs no recommendation,
 * prioritization, approval, or resolution logic.
 */
export function createDecisionMatter({
  id = null,
  businessQuestion = null,
  decisionRequired = null,
  context = null,
  trigger = null,
  alternatives = [],
  recommendedAlternative = null,
  recommendation = null,
  supportingEvidence = [],
  financialImpact = null,
  riskImpact = null,
  recommendationStatus = null,
  governanceStatus = GOVERNANCE_LIFECYCLE_STATUSES.DRAFT,
  metadata = null,
  sourceRecommendation = null,
  createdFromRecommendationId = null,
  sourceReference = null,
} = {}) {
  return {
    id,
    businessQuestion,
    decisionRequired,
    context,
    trigger,
    alternatives: Array.isArray(alternatives)
      ? [...alternatives]
      : [],
    recommendedAlternative,
    recommendation,
    supportingEvidence: Array.isArray(supportingEvidence)
      ? [...supportingEvidence]
      : [],
    financialImpact,
    riskImpact,
    // Analytical state is copied for visibility only; governance state remains
    // an independent property owned by the Decision Matter.
    recommendationStatus,
    governanceStatus: normalizeStatus(governanceStatus),
    metadata,
    sourceRecommendation,
    createdFromRecommendationId,
    sourceReference,
  };
}
